import React from 'react'
import {
  Route,
  Routes,
} from 'react-router-dom'

import { DynamicProfileScreen } from '../../components/dynamicLighting/DynamicProfileScreen/DynamicProfileScreen'
import { CreateDynamicProfileScreen } from '../../components/dynamicLighting/DynamicProfileScreen/CreateDynamicProfileScreen/CreateDynamicProfileScreen'
import { UpdateDynamicProfileFormScreen } from '../../components/dynamicLighting/DynamicProfileScreen/DynamicProfileFormScreen/UpdateDynamicProfileFormScreen/UpdateDynamicProfileFormScreen'
import { CreateDynamicProfileFormScreen } from '../../components/dynamicLighting/DynamicProfileScreen/DynamicProfileFormScreen/CreateDynamicProfileFormScreen/CreateDynamicProfileFormScreen'
import { DynamicConfigurationScreen } from '../../components/dynamicLighting/DynamicConfigurationScreen/DynamicConfigurationScreen'

export const DynamicLightingRouter = () => {

  return (
    <Routes>

      <Route
        path='profiles'
        element={<DynamicProfileScreen />}
      />
      <Route path='profiles/panels' element={<CreateDynamicProfileScreen />} />
      <Route path='profiles/panels/create' element={<CreateDynamicProfileFormScreen />} />
      <Route path='profiles/panels/update' element={<UpdateDynamicProfileFormScreen />} />
      <Route path='configuration' element={<DynamicConfigurationScreen />} />

    </Routes>
  )
}